import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
`;

export const Section = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  margin: 0 -24px;
  padding: 0 24px;
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const Item = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${RFValue(10)}px;
`;

export const ItemTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const ItemName = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
`;

export const InfoBanner = styled.View`
  flex-direction: row;
  background-color: ${({theme}) => theme.colors.gold_opacity};
  border: 1px solid ${({theme}) => theme.colors.gold};
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(10)}px;
  margin-bottom: ${RFValue(8)}px;
`;

export const InfoBannerText = styled.Text`
  flex: 1;
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
  line-height: ${RFValue(16)}px;
`;
